<template>
  <div class="switch-container" :class="{'turned-on': turnedOn}">

    <span class="off">Off</span>

    <span class="switch" @click="toggle">
      <div class="circle"></div>
    </span>

    <span class="on">On</span>

  </div>
</template>

<script>
export default {
  data: () => {
    return {
      state: false
    }
  },
  props: ["value"],
  computed: {
    turnedOn() {
      return this.state;
    }
  },
  mounted() {
    this.state = (this.value) ? true : false;
  },
  methods: {
    toggle() {
      this.state = !this.state;
      this.$emit('input', this.state ? 1 : 0 );
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.state = (newVal) ? true : false;
    }
  }
}
</script>

<style lang="scss" scoped>
.switch-container {
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .on {
    color: rgba($color: #ffffff, $alpha: 0.4);
  }
  .off {
    color: rgba($color: #ffffff, $alpha: 1);
  }
  .on, .off {
    transition: color 0.3s cubic-bezier(.25,.8,.25,1);
  }

  .switch {
    display: inline-block;
    margin: 0 8px;
    width: 42px;
    height: 24px;
    background-color: #4D4D4D;
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.3s cubic-bezier(.25,.8,.25,1);
    
    .circle {
      height: 20px;
      width: 20px;
      background-color: #fff;
      opacity: 1;
      border-radius: 50%;
      margin: 2px;
      position: relative;
      transition: margin 0.3s cubic-bezier(.25,.8,.25,1);
    }
  }
  &.turned-on {
    .switch {
      background-color: #5BD849;
      .circle {
        margin-left: 20px;
      }
    }
    .on {
      color: rgba($color: #ffffff, $alpha: 1);
    }
    .off {
      color: rgba($color: #ffffff, $alpha: 0.4);
    }
  }
}
</style>